define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/store/Values",
	"csi/xml/Query",
	"csi/xml",
], function(declare,lang,Controller,PostRequest,locale,ValuesStore,Query,xml) {
	var PLACEMENT_PRODUCT_TYPE  = "PlacementProductType";

	return declare(Controller, {

		/**
		 *  If creating new node, then add Save & New action as well
		 * @param {*} defView - View
		 * @param {*} defActions - Actions
		 */
		addProxyActions: function(defView, defActions) { 
			defActions.addAction(this.getProxyAction("Save_New", true, {m_bRepeat: true, m_name:locale.resource("Save_Repeat")}));
			defActions.addAction(this.getProxyAction("Save", true, {m_bSubmit: true}));
			this.inherited(arguments);
		},

		/**
		 *  Add any requests necessary to fetch data before executing action
		 *  C8-28509 Removing the sections that contains only ProductType:Style
		 * 	For Section to support Both Style and Material the PlacementProductType is empty.
		 */
		_preAction: function() {
            var q = new Query().Type("PartMaterial");
            q.Not()
                .Attr(PLACEMENT_PRODUCT_TYPE, xml.OP_EQUALS, "ProductType:Style", "Child:DSSection");
            this._sectionsStore = new ValuesStore({
                bBlanks: true,
                filterQuery: q,
                requestParameters: {
                    "Qry.Value.Locale": locale.getLocale(),
                    "Qry.Limit.Path": xml.getUrlPath(this.getParentURL(), xml.path("Items")),
                    "Qry.Value.Path": "Child:DSSection",
                    "Qry.Value.Node": "Name"
                }
            });

            return this._sectionsStore.query();
        },

		/**
		 * Issue request so as to be able to receive return value
		 */
		process: function() {
			var	req = this.m_action.m_request;

			this.setProgress();

			var fd = this.m_formData;

			new PostRequest(req.m_module, req.m_operation)
				.addParameter("ParentURL", this.m_urlParent)
	            .addParameter("PartMaterials",fd.getFieldValue("PartMaterials"))
	            .addParameter("Colorways", fd.getFieldValue("Colorways"))
	            .addParameter("ColorSpecificationFrom",fd.getFieldValue("From"))
	            .addParameter("ColorSpecificationTo",fd.getFieldValue("To"))
				.post({}).then(lang.hitch(this, this._onPublishResponse));
		}
	});
});